/**
 * Validates that data is in InfraGraph format (not legacy infra.proto format)
 *
 * Checks for required fields: instances, edges, devices
 * Note: 'links' can be at top level or inside devices, so it's not required at top level
 *
 * @param data - The parsed data to validate
 * @param filename - Optional filename for error messages
 * @throws Error if validation fails with descriptive message
 */
export function validateInfragraphFormat(data: any, filename?: string): void {
  const fileRef = filename ? ` in ${filename}` : '';

  // Validate that it's in infragraph format
  // Note: 'links' can be at top level or inside devices, so we only check for required fields
  if (!data.instances || !data.edges || !data.devices) {
    throw new Error(
      `Invalid InfraGraph format${fileRef}. ` +
      `File must contain 'instances', 'edges', and 'devices' fields. ` +
      `Legacy infra.proto format is no longer supported. Please see infragraph.dev for reference.`
    );
  }
}
